import { inject } from 'mobx-react';
import { ToolbarType, UitkToolbar } from 'uitk-react-toolbar';
import { UitkDialogAnimationType, UitkFullscreenDialog } from 'uitk-react-dialog';
import { UitkIcon } from 'uitk-react-icons';
import { UitkLink } from 'uitk-react-link';
import { UitkTertiaryButton } from 'uitk-react-button';
import * as React from 'react';

import { formatText } from 'bernie-l10n';
import { Layer, ViewLarge, ViewMedium, Viewport, ViewSmall } from 'bernie-view';
import { QueryRoute, RouteStore } from 'bernie-core';

import { FooterLink } from 'src/common/types/flex-definitions';

interface SWXLFooterSectionProps {
  headerTitle: string;
  title: string;
  links: FooterLink[];
  routeStore?: RouteStore;
  indexKey: number;
}

@inject('routeStore')
export class SwxlFooterSection extends React.Component<SWXLFooterSectionProps> {
  private pwaDialog: { pwaDialog: string };

  private openDialog = () => {
    if (this.props.routeStore) {
      this.props.routeStore.updateSearch(this.pwaDialog);
    }
  };

  private closeDialog = () => {
    if (this.props.routeStore) {
      this.props.routeStore.goBack();
    }
  };

  public render() {
    const { headerTitle, title, links, indexKey } = this.props;

    if (!links || !title || links.length === 0) {
      return null;
    }

    const linksJSX = links.map((link, index) => (
      <UitkLink key={`footer-link-${indexKey}-${index}`}>
        <p>
          <a href={link.url ? link.url : link.link}>{link.text ? link.text : link.label}</a>
        </p>
      </UitkLink>
    ));

    const createColumns = (linkArray, rows) => {
      const tempArray = [];
      const defaultRows = 10;
      rows = rows < defaultRows ? defaultRows : rows;

      for (let i = 0; i < linkArray.length; i += rows) {
        const column = linkArray.slice(i, i + rows);
        tempArray.push(column);
      }

      return tempArray;
    };

    const formattedTitle = title.replace(' ', '-');
    this.pwaDialog = { pwaDialog: formattedTitle };

    const resultsCount = links.length;
    const resultsText =
      resultsCount === 1
        ? formatText('hotels.infosite.sxwl.footer.single.result')
        : formatText('hotels.infosite.sxwl.footer.multiple.results', resultsCount);

    return (
      <React.Fragment>
        <UitkTertiaryButton
          className="all-y-padding-two uitk-cell"
          onClick={this.openDialog}
          style={{
            /*This is a very specific fix for IE11. More info: https://github.expedia.biz/Brand-Expedia/shopping-pwa/pull/2941*/
            height: 'auto'
          }}
        >
          <div className="uitk-flex uitk-flex-grow-1 uitk-flex-justify-content-space-between uitk-flex-align-items-center">
            <div className="all-cell-align-start">
              <p className="uitk-type-heading-400 uitk-type-left">{title}</p>
              <p className="uitk-type-200 pwa-theme--grey-700 uitk-type-left">{resultsText}</p>
            </div>
            <UitkIcon name="chevron_right" className="all-cell-align-end uitk-type-heading-400" />
          </div>
        </UitkTertiaryButton>
        <div className="is-visually-hidden">{linksJSX}</div>
        <QueryRoute query={this.pwaDialog}>
          <Layer id={formattedTitle}>
            <UitkFullscreenDialog dialogShow={true} animation={UitkDialogAnimationType.SLIDEUP} strictFullscreen={true}>
              <div className="uitk-cell">
                <UitkToolbar action={this.closeDialog} type={ToolbarType.BACK} header={headerTitle} />
              </div>
              <div className="uitk-dialog-content all-x-padding-four all-y-padding-four">
                <div className="uitk-type-heading-600 all-y-padding-four">{title}</div>
                <Viewport>
                  <ViewSmall>
                    <div className="uitk-dialog-content">{linksJSX}</div>
                  </ViewSmall>
                  <ViewMedium>
                    <div className="uitk-grid all-cell-1-2 all-x-gutter-six">
                      {createColumns(linksJSX, linksJSX.length / 2).map((link, index) => (
                        <div key={`link-m-${index}`} className="uitk-cell">
                          {link}
                        </div>
                      ))}
                    </div>
                  </ViewMedium>
                  <ViewLarge>
                    <div className="uitk-grid all-cell-1-3 all-x-gutter-six">
                      {createColumns(linksJSX, linksJSX.length / 3).map((link, index) => (
                        <div key={`link-l-${index}`} className={`uitk-cell`}>
                          {link}
                        </div>
                      ))}
                    </div>
                  </ViewLarge>
                </Viewport>
              </div>
            </UitkFullscreenDialog>
          </Layer>
        </QueryRoute>
      </React.Fragment>
    );
  }
}
